import { render, staticRenderFns } from "./ExportImport.vue?vue&type=template&id=2924ef0d&scoped=true"
import script from "./ExportImport.vue?vue&type=script&lang=js"
export * from "./ExportImport.vue?vue&type=script&lang=js"
import style0 from "./ExportImport.vue?vue&type=style&index=0&id=2924ef0d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2924ef0d",
  null
  
)

export default component.exports